// Cinematic hero montage — full-bleed flashes of music moments (Compton-Cowboys style).
// Each image cross-fades through a fixed slot; Ken Burns zoom runs while visible.
const FLASHES = [
  "/brand/hero/moment-concert.webp",
  "/brand/hero/moment-studio.webp",
  "/brand/hero/moment-dj.jpg",
  "/brand/hero/moment-vinyl.webp",
];

const SLOT = 3.2; // seconds each moment is on screen
const CYCLE = SLOT * FLASHES.length;

export default function HeroMontage() {
  const step = 100 / FLASHES.length; // keyframe window per moment
  const keyframes = `@keyframes hero-flash-cycle {
    0% { opacity: 0; transform: scale(1.02); }
    ${(step * 0.08).toFixed(2)}% { opacity: 1; }
    ${(step * 0.92).toFixed(2)}% { opacity: 1; transform: scale(1.093); }
    ${step.toFixed(2)}% { opacity: 0; transform: scale(1.1); }
    100% { opacity: 0; transform: scale(1.1); }
  }`;

  return (
    <div
      className="hero-fade-bottom absolute inset-0 overflow-hidden bg-[#050508]"
      data-testid="hero-montage"
      aria-hidden="true"
    >
      <style>{keyframes}</style>
      {FLASHES.map((src, i) => (
        <img
          key={src}
          src={src}
          alt=""
          draggable="false"
          decoding="async"
          fetchpriority={i === 0 ? "high" : undefined}
          className={`hero-flash-img ${src.includes("moment-concert") ? "hero-flash-warm" : ""}`}
          style={{
            animationDelay: `${(i * SLOT).toFixed(2)}s`,
            animationDuration: `${CYCLE}s`,
            "--slot": `${SLOT}s`,
          }}
        />
      ))}
      <div className="hero-flash-shade" />
    </div>
  );
}